import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


import AboutTabsProps from "../../model/about-tabs-props";
const background: string = '#424348';

export default function AboutTab(props : AboutTabsProps){
    return(
        <Card variant="outlined" sx={{ padding: 2, background: background,marginBottom:2}}>
            <Box display='flex' justifyContent='space-between'>
                <Typography component='h2' variant='h5' color='#fff' fontWeight='medium'>
                        {props.heading}
                </Typography>
                {props.endIcon}
            </Box>

            <Typography component='p' variant='caption' color='#fff' fontWeight='light'>
                {props.description}
            </Typography>

            <Typography component='p' variant='body2' color='rgba(255,255,255,60%)' fontWeight='bold' textTransform='uppercase' sx={{ textDecoration:'underline', paddingTop:2}}>
                {props.projectCount} PROJECTS
            </Typography>
        </Card>
    );
}